import { useState } from "react";
import { Copy, Mail, MessageCircle, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

export function ShareSheet({ open, onClose, title, desc, text, link, testId = "share-sheet" }) {
  const full = `${text} ${link}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Link copied"); } catch { toast.error("Couldn't copy, please copy the link above"); }
  };
  const native = async () => { try { await navigator.share({ title, text, url: link }); } catch { /* cancelled */ } };
  const btn = "flex items-center justify-center gap-2 border border-[#D4AF37]/40 hover:bg-[#D4AF37]/10 text-[#E8DCC4] py-3 rounded-full transition-colors";
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" data-testid={testId} className="max-w-md mx-auto bg-[#0B0F19] border-t border-[#D4AF37]/30 text-starlight rounded-t-3xl">
        <SheetHeader className="text-left">
          <SheetTitle className="text-2xl font-light text-starlight">{title}</SheetTitle>
          <SheetDescription className="text-[#A7B0C0]">{desc}</SheetDescription>
        </SheetHeader>
        <p className="mt-4 text-sm bg-[#0F1523] border border-[#D4AF37]/15 rounded-xl px-3 py-2.5 break-all text-[#D6D0C5]" data-testid={`${testId}-link`}>{link}</p>
        <div className="grid grid-cols-2 gap-2.5 mt-4 mb-3">
          {typeof navigator !== "undefined" && navigator.share && (
            <button className={`${btn} col-span-2 bg-[#D4AF37] text-[#04060B] hover:bg-[#e6c04e] border-0 font-medium`} onClick={native} data-testid={`${testId}-native`}><Share2 size={16} /> Share</button>
          )}
          <a className={btn} href={`https://wa.me/?text=${encodeURIComponent(full)}`} target="_blank" rel="noreferrer" data-testid={`${testId}-whatsapp`}><MessageCircle size={16} /> WhatsApp</a>
          <a className={btn} href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(full)}`} data-testid={`${testId}-email`}><Mail size={16} /> Email</a>
          <button className={`${btn} col-span-2`} onClick={copy} data-testid={`${testId}-copy`}><Copy size={16} /> Copy link</button>
        </div>
      </SheetContent>
    </Sheet>
  );
}

export function useShareState() {
  const [open, setOpen] = useState(false);
  return { open, show: () => setOpen(true), hide: () => setOpen(false) };
}
